export function formatDate(date?: Date): string {
  if (!date) {
    return "";
  }
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // getMonth() is zero-based
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}
